import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EpdkShimmerComponent } from './shimmer.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EpdkShimmerComponent],
  exports: [EpdkShimmerComponent]
})
export class EpdkShimmerModule { }